import { Fragment } from "react";

const INLINE = /(\*[^*\n]+\*|_[^_\n]+_|~[^~\n]+~|https?:\/\/[^\s]+|@[A-Za-zÀ-ÿ'-]+(?: [A-ZÀ-Ý][A-Za-zÀ-ÿ'-]+)?)/g;

function Inline({ text }) {
  const parts = text.split(INLINE);
  return parts.map((p, i) => {
    if (!p) return null;
    if (/^\*[^*]+\*$/.test(p)) return <strong key={i}>{p.slice(1, -1)}</strong>;
    if (/^_[^_]+_$/.test(p)) return <em key={i}>{p.slice(1, -1)}</em>;
    if (/^~[^~]+~$/.test(p)) return <s key={i}>{p.slice(1, -1)}</s>;
    if (/^https?:\/\//.test(p)) return <a key={i} href={p} target="_blank" rel="noopener noreferrer" className="underline text-mr-accent break-all">{p}</a>;
    if (p.startsWith("@")) return <span key={i} className="text-mr-accent font-medium">{p}</span>;
    return <Fragment key={i}>{p}</Fragment>;
  });
}

export function RichText({ text = "" }) {
  const lines = text.split("\n");
  const out = [];
  let list = [];
  const flush = () => {
    if (list.length) out.push(<ul key={`l${out.length}`} className="list-disc pl-5 my-1">{list.map((l, i) => <li key={i}><Inline text={l} /></li>)}</ul>);
    list = [];
  };
  lines.forEach((l, i) => {
    if (/^[-•] /.test(l)) {
      list.push(l.slice(2));
      return;
    }
    flush();
    out.push(<p key={`p${i}`} className="min-h-[1em]"><Inline text={l} /></p>);
  });
  flush();
  return <div className="whitespace-pre-wrap break-words">{out}</div>;
}

export const slowNetwork = () => {
  const c = navigator.connection;
  return !!c && (c.saveData || ["slow-2g", "2g", "3g"].includes(c.effectiveType));
};
